/**
 * Ghost challenge links, client side. A challenge URL is /r/<id>; the
 * Worker rewrites the social tags for crawlers, and the game reads the
 * same path on boot to open the challenge. Pure helpers here so the node
 * suite can pin the path grammar and the share text.
 */

export const CHALLENGE_PATH_RE = /^\/r\/([a-z0-9]{10})$/;

export function challengeIdFromPath(pathname) {
  return String(pathname ?? '').match(CHALLENGE_PATH_RE)?.[1] ?? null;
}

/** The line that travels with the link through the share sheet. */
export function shareText({ name, levelName, time }) {
  return `${name} ran ${levelName} in ${Number(time).toFixed(2)}s in MOMENTUM. Beat it.`;
}

/** Native share sheet where there is one (phones), clipboard elsewhere.
 *  Returns how the link left: 'shared' | 'copied' | null (nothing worked;
 *  the caller shows the URL instead). */
export async function deliverLink({ title, text, url }) {
  if (typeof navigator.share === 'function' && (navigator.canShare?.({ url }) ?? true)) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (err) {
      // A dismissed sheet is not a failure worth a second prompt.
      if (err?.name === 'AbortError') return 'shared';
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch {
    return null;
  }
}
